import colors from 'src/scss/styleguide/_exports.module.scss';

type DigitalProductStateKey =
  | 'UNPUBLISHED'
  | 'REVIEW'
  | 'PUBLISHED'
  | 'REJECTED';

type DigitalProductState = {
  key: DigitalProductStateKey;
  name: string;
  description: string;
  color: string;
};

export const DIGITAL_PRODUCTS_STATES: Record<
  DigitalProductStateKey,
  DigitalProductState
> = {
  UNPUBLISHED: {
    key: 'UNPUBLISHED',
    name: 'DIGITAL_PRODUCTS.STATUS.UNPUBLISHED.NAME',
    description: 'DIGITAL_PRODUCTS.STATUS.UNPUBLISHED.DESCRIPTION',
    color: colors.paColorMain,
  },
  REVIEW: {
    key: 'REVIEW',
    name: 'DIGITAL_PRODUCTS.STATUS.REVIEW.NAME',
    description: 'DIGITAL_PRODUCTS.STATUS.REVIEW.DESCRIPTION',
    color: colors.grey65,
  },
  PUBLISHED: {
    key: 'PUBLISHED',
    name: 'DIGITAL_PRODUCTS.STATUS.PUBLISHED.NAME',
    description: 'DIGITAL_PRODUCTS.STATUS.PUBLISHED.DESCRIPTION',
    color: colors.paColorGreen,
  },
  REJECTED: {
    key: 'REJECTED',
    name: 'DIGITAL_PRODUCTS.STATUS.REJECTED.NAME',
    description: 'DIGITAL_PRODUCTS.STATUS.REJECTED.DESCRIPTION',
    color: colors.paColorRed,
  },
} as const;

type DigitalProductUpdateStateKey = 'REVIEW' | 'REJECTED' | 'NONE';

type DigitalProductUpdateState = {
  key: DigitalProductUpdateStateKey;
  name: string;
};

export const DIGITAL_PRODUCTS_UPDATE_STATES: Record<
  DigitalProductUpdateStateKey,
  DigitalProductState
> = {
  REVIEW: {
    key: 'REVIEW',
    name: 'Review',
  },
  REJECTED: {
    key: 'REJECTED',
    name: 'Rejected',
  },
  NONE: {
    key: 'NONE',
    name: 'None',
  },
} as const;

export function getDigitalProductState(digitalProduct): DigitalProductState {
  if (digitalProduct.hasApprovedRevision && digitalProduct.shopIds.length) {
    return DIGITAL_PRODUCTS_STATES.PUBLISHED;
  } else if (
    digitalProduct.hasApprovedRevision &&
    !digitalProduct.shopIds.length
  ) {
    return DIGITAL_PRODUCTS_STATES.UNPUBLISHED;
  } else if (digitalProduct.latestRevisionPublishState === 'REJECTED') {
    return DIGITAL_PRODUCTS_STATES.REJECTED;
  } else if (
    !digitalProduct.hasApprovedRevision &&
    ['PENDING_REVIEW', 'IN_REVIEW'].includes(
      digitalProduct.latestRevisionPublishState,
    )
  ) {
    return DIGITAL_PRODUCTS_STATES.REVIEW;
  } else {
    return DIGITAL_PRODUCTS_STATES.UNPUBLISHED;
  }
}

export function getDigitalProductUpdateState(
  digitalProduct,
): DigitalProductUpdateState {
  if (
    digitalProduct.hasApprovedRevision &&
    ['PENDING_REVIEW', 'IN_REVIEW'].includes(
      digitalProduct.latestRevisionPublishState,
    )
  ) {
    return DIGITAL_PRODUCTS_UPDATE_STATES.REVIEW;
  } else if (
    digitalProduct.hasApprovedRevision &&
    digitalProduct.latestRevisionPublishState === 'REJECTED'
  ) {
    return DIGITAL_PRODUCTS_UPDATE_STATES.REJECTED;
  } else {
    return DIGITAL_PRODUCTS_UPDATE_STATES.NONE;
  }
}
